// third-party
import { createSlice } from '@reduxjs/toolkit';

// project-imports
import axios from 'utils/axios';
import { dispatch } from '../index';

// types
import { chat } from './chat';
import { setNotificationNoticeSeenAt } from './auth';
import { showSuccessToast } from 'utils/showSuccessToast';
import { NotificationSettingsData, NotificationSettingsStateProps } from 'types/notificationSettings';

export const urlSettings = process.env.REACT_APP_API_URL + '/api/settings/v1/notification';
const urlNoticeSeen = process.env.REACT_APP_API_URL + '/api/user/v1/notification-notice-seen';

const SAVED_MESSAGE = 'Configurações salvas. Valem para os próximos usuários criados.';

const initialState: NotificationSettingsStateProps = {
  settings: null
};

export const notificationSettings = createSlice({
  name: 'notificationSettings',
  initialState,
  reducers: {
    setSettings(state, action) {
      state.settings = action.payload;
    }
  }
});

export function getNotificationSettings() {
  return async () => {
    try {
      const response = await axios.get(urlSettings);
      dispatch(notificationSettings.actions.setSettings(response.data));
    } catch (error) {
      dispatch(chat.actions.hasError(error));
    }
  };
}

export function saveNotificationSettings(patch: Partial<NotificationSettingsData>) {
  return async () => {
    try {
      const response = await axios.put(urlSettings, patch);
      dispatch(notificationSettings.actions.setSettings(response.data));
      showSuccessToast(SAVED_MESSAGE);
    } catch (error) {
      dispatch(chat.actions.hasError(error));
      throw error;
    }
  };
}

// dispara uma vez, no primeiro login em que o usuário ainda não viu o aviso da política de
// notificação — ver NotificationPolicyNotice. Falha silenciosa: não é crítico re-tentar depois
export function markNotificationNoticeSeen() {
  return async () => {
    try {
      await axios.put(urlNoticeSeen);
      dispatch(setNotificationNoticeSeenAt(new Date().toISOString()));
    } catch (error) {
      // silencioso de propósito — só um aviso informativo, não trava nada se falhar
    }
  };
}

export default notificationSettings.reducer;
